import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Router, RoutesRecognized } from "@angular/router";
import { Observable, Subscription } from "rxjs";

import { Constants } from "./../../constants/constants";
import { AuthService } from "./../../services/auth.service";
import { LoginService } from "../../pages/login/login.service";
import { UsersService } from "../../pages/account-management/users/users.service";
import { map } from "rxjs/operators";
import { NavigationService } from "../navigation/navigation.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { AppService } from "src/app/app.service";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ZxBreadcrumbsComponent } from "../shared/zx-breadcrumbs/zx-breadcrumbs.component";
import { TimeSettingsComponent } from "../shared/time-settings/time-settings.component";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-topbar",
    templateUrl: "./topbar.component.html",
    imports: [
        CommonModule,
        TranslateModule,
        FontAwesomeModule,
        NgbDropdownModule,
        ZxBreadcrumbsComponent,
        TimeSettingsComponent
    ]
})
export class TopbarComponent implements OnInit, OnDestroy {
    private router = inject(Router);
    private userService = inject(UsersService);
    private authService = inject(AuthService);
    private loginService = inject(LoginService);
    private navigationService = inject(NavigationService);
    private mixpanelService = inject(MixpanelService);
    appService = inject(AppService);

    isLoggedIn$: Observable<boolean>;
    userName$: Observable<string>;
    impersonating$: Observable<boolean>;
    dnsPrefix$: Observable<string>;
    isNavExpanded$: Observable<boolean>;
    helpConfigs: { menu: string; link: string }[];

    private isNavVisibleSubscription: Subscription;
    navigationVisible: boolean;
    private isDarkModeSubscription: Subscription;
    isDarkMode: boolean;

    constructor() {
        const router = this.router;

        router.events.subscribe(event => {
            if (event instanceof RoutesRecognized) {
                const route = event.state.root.firstChild?.firstChild;
                this.helpConfigs = route?.data.help;
            }
        });
    }

    async ngOnInit() {
        this.isLoggedIn$ = this.authService.isLoggedIn;
        this.userName$ = this.userService.user.pipe(map(u => u.name));
        this.impersonating$ = this.userService.user.pipe(map(u => u.impersonating));
        this.dnsPrefix$ = this.userService.user.pipe(map(u => u.dns_prefix));

        setTimeout(() => {
            this.isNavExpanded$ = this.navigationService.isNavExpanded;
        });

        this.isNavVisibleSubscription = this.navigationService.isNavVisible.pipe().subscribe(bool => {
            this.navigationVisible = bool;
        });

        this.isDarkModeSubscription = this.navigationService.isDarkMode.pipe().subscribe(bool => {
            this.isDarkMode = bool;
        });
    }

    ngOnDestroy() {
        this.navigationService.setNavVisbility(true);
        this.isNavVisibleSubscription.unsubscribe();
        this.isDarkModeSubscription.unsubscribe();
    }

    toggleNav() {
        this.navigationService.toggle$.next();
    }

    toggleDarkMode() {
        this.navigationService.setDarkMode(!this.isDarkMode);
    }

    myAccount() {
        this.router.navigate([Constants.urls.accountManagement.myAccount]);
    }

    goToHome() {
        this.router.navigate([Constants.urls.dashboard]);
    }

    help(link?: string) {
        if (link) {
            window.open(link, "_blank");
            this.mixpanelService.sendEvent("direct help link", {
                link: link
            });
        } else {
            window.open("https://docs.zixi.com/zen-master/zen-master-user-guide", "_blank");
            this.mixpanelService.sendEvent("base help link");
        }
    }

    reportIssue() {
        window.open("https://support.zixi.com/contact-support", "_blank");
    }

    logout() {
        this.loginService.logout(true);
        this.router.navigate([Constants.urls.login]);
    }
}
